<template>
  <div :key="refresh_key">
    <!-- *** IME **** -->
    <form-input
      :invalid="invalid_elements.ime"
      label="Ime"
      id="ime"
      ref="imeFiz"
      required="required"
      :base="fizicka.ime"
    ></form-input>
    <!-- *** Prezime **** -->
    <form-input
      :invalid="invalid_elements.prezime"
      label="Prezime"
      id="prezime"
      ref="prezimeFiz"
      required="required"
      :base="fizicka.prezime"
    ></form-input>
    <!-- OIB -->
    <form-input label="OIB" id="oib" ref="OIB" :base="fizicka.oib"></form-input>
    <div class="form-input-wrapper">
      <label class="form-label" for="datum-rodjenja">
        <span>Datum rođenja</span>
      </label>
      <div>
        <input
          class="form-input"
          type="date"
          id="datum-rodjenja"
          ref="datumRodjenja"
          name="datum-rodjenja"
          @input="fizicka.rodjendan = $event.target.value"
          v-model="fizicka.rodjendan"
        />
      </div>
    </div>

    <!-- *** Email *** -->
    <form-input-multiple
      ref="email"
      :name="'email'"
      :label="'Email'"
      :placeholder="'Unesite novu email adresu'"
      :base="fizicka.email_list"
    />
    <!-- *** Broj telefona *** -->
    <form-input-multiple
      ref="telefon"
      :name="'telefon'"
      :label="'Broj telefona'"
      :placeholder="'Unesite novi broj telefona'"
      :base="fizicka.tel_br_list"
    />
    <!-- *** Web stranica *** -->
    <form-input-multiple
      ref="stranica"
      :name="'stranica'"
      :label="'Web stranica'"
      :placeholder="'Unesite novu web stranicu'"
      :base="fizicka.web_list"
    />

    <div class="form-divider"></div>
    <adresa-element ref="adresaElement" :base="fizicka.adrese_list" />

    <div class="form-divider"></div>
    <!-- *** INDUSTRIJA **** -->
    <form-drop-down
      label="Industrija"
      id="industrija"
      ref="industrija"
      :dropImport="industrija"
      :base="fizicka.industrija_id.ID"
    ></form-drop-down>

    <!-- *** Godišnji prihod **** -->
    <form-input
      label="Godišnji prihod"
      id="godisnji-prihod"
      ref="godisnjiPrihod"
      :base="fizicka.god_prihod"
    ></form-input>

    <!-- *** Tip izvora **** -->
    <form-drop-down
      label="Tip izvora"
      id="tip-izvor"
      ref="tipIzvor"
      :dropImport="tipovi_izvora"
      :base="fizicka.id_tip_izvora.ID"
    ></form-drop-down>
    <form-autocomplete-single
      :invalid="invalid_elements.izvor"
      :style="fizicka.id_tip_izvora.ID <= 3 ? 'display:flex' : 'display:none'"
      :name="'imeIzvora'"
      :start="fizicka.id_tip_izvora.ID == 1 ? fizicka.izvor_fizicka_osoba: fizicka.id_tip_izvora.ID == 2 ?fizicka.izvor_pravna_osoba : fizicka.izvor_team"
      :placeholder="
        fizicka.id_tip_izvora.ID == 1
          ? 'Odaberite fizičku osobu'
          : fizicka.id_tip_izvora.ID == 2
          ? 'Odaberite pravnu osobu'
          : 'Odaberite člana tima'
      "
      :type="'Izvor'"
      :id="'izvor'"
      ref="imeIzvora"
      :items="
        fizicka.id_tip_izvora.ID == 1
          ? fizicke
          : fizicka.id_tip_izvora.ID == 2
          ? pravne
          : clanovi
      "
    ></form-autocomplete-single>
    <!-- *** Izvor izvan sustava **** -->
    <form-input
      :invalid="invalid_elements.custom_ime_izvora"
      :style="fizicka.id_tip_izvora.ID == 4 ? 'display:flex' : 'display:none'"
      label="Izvor izvan sustava "
      id="custom-izvor"
      ref="customIzvor"
      :base="fizicka.custom_ime_izvora"
    ></form-input>
    <!-- *** Drugi kontakt ****
    <form-input
      label="Drugi kontakt"
      id="drugi-kontakt"
      ref="drugiKontakt"
    ></form-input> -->
    <!-- *** Radno vrijeme **** -->
    <form-input
      label="Radno vrijeme"
      id="radno-vrijeme"
      ref="radnoVrijeme"
      :base="fizicka.radno_vrijeme"
    ></form-input>
    <!-- *** OPIS **** -->
    <form-textarea label="Opis" id="opis" ref="opis" :base="fizicka.opis"></form-textarea>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import formInputMultiple from "@/components/formElements/formInputMultiple.vue";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import $ from "jquery";

export default {
  data() {
    return {
      refresh_key: 1,
      fizicka: {
        ime: "",
        prezime: "",
        oib: "",
        email_list: [],
        tel_br_list: [],
        adrese_list: [],
        web_list: [],
        industrija_id:{ID:1},
        god_prihod: "",
        id_tip_izvora:{ID:5},
        izvor_osoba: "",
        custom_ime_izvora: "",
        radno_vrijeme: "",
        opis: "",
        rodjendan: "",
      },
    };
  },
  async created() {
    let route_name = this.$router.history.current.name;
    if (route_name === "PhisicalPersonEdit") {
      console.log(this.$router.history.current.params.oib);
      await osobe
        .getEditPhisEntity(this.$router.history.current.params.oib)
        .then(async (resp) => {
          console.log("OSOBA:")
          const fiz_temp =JSON.parse(resp.data);
          console.log(fiz_temp)
          this.$refs.imeFiz.$data.value = fiz_temp.ime == null ? '':fiz_temp.ime;
          this.$refs.prezimeFiz.$data.value = fiz_temp.prezime == null ? '':fiz_temp.prezime
          this.$refs.OIB.$data.value = fiz_temp.oib == null ? '':fiz_temp.oib
          this.$refs.industrija.$data.ID = fiz_temp.industrija_id;
          this.$refs.godisnjiPrihod.$data.value = fiz_temp.god_prihod == null ? '':fiz_temp.god_prihod;
          this.$refs.tipIzvor.$data.ID = fiz_temp.id_tip_izvora;
          this.$refs.adresaElement.$data.lista_adresa = fiz_temp.adresa == null ? [] : fiz_temp.adresa;

          this.$refs.email.$data.values = fiz_temp.email_list
          this.$refs.telefon.$data.values = fiz_temp.tel_br_list;
          this.$refs.stranica.$data.values = fiz_temp.web_list;
          this.$refs.customIzvor.$data.value = fiz_temp.custom_ime_izvora == null ? '':fiz_temp.custom_ime_izvora;
          this.$refs.radnoVrijeme.$data.value = fiz_temp.radno_vrijeme == null ? '': fiz_temp.radno_vrijeme;
          this.$refs.opis.$data.value = fiz_temp.opis == null ? '' : fiz_temp.opis;
          
          this.fizicka.rodjendan= fiz_temp.rodjendan==null ? '': new Date(fiz_temp.rodjendan).toISOString().substr(0, 10);
          switch (fiz_temp.id_tip_izvora) {
            case 1:
              this.$refs.imeIzvora.$data.results_final.uid =fiz_temp.fizicka_osoba.uid;
              this.$refs.imeIzvora.$data.results_final.name = fiz_temp.fizicka_osoba.ime +' '+fiz_temp.fizicka_osoba.prezime
              break;
            case 2:
              this.$refs.imeIzvora.$data.results_final.uid =fiz_temp.pravna_osoba_fizicka_osoba_src_leg_uidTopravna_osoba.uid;
              this.$refs.imeIzvora.$data.results_final.name = fiz_temp.pravna_osoba_fizicka_osoba_src_leg_uidTopravna_osoba.ime
              break;
            case 3:
              this.$refs.imeIzvora.$data.results_final.uid =fiz_temp.odvjetnik_fizicka_osoba_src_team_uidToodvjetnik.uid;
              this.$refs.imeIzvora.$data.results_final.name = fiz_temp.odvjetnik_fizicka_osoba_src_team_uidToodvjetnik.ime +' '+fiz_temp.odvjetnik_fizicka_osoba_src_team_uidToodvjetnik.prezime
              break;
            default:
              break;
          }
          this.$emit("finished");
        });
    }
  },
  mounted() {
    this.$refs.tipIzvor.$data.ID = 5;
    this.fizicka.ime = this.$refs.imeFiz.$data;
    this.fizicka.prezime = this.$refs.prezimeFiz.$data;
    this.fizicka.oib = this.$refs.OIB.$data;
    this.fizicka.industrija_id = this.$refs.industrija.$data;
    this.fizicka.god_prihod = this.$refs.godisnjiPrihod.$data;
    this.fizicka.id_tip_izvora = this.$refs.tipIzvor.$data;
    this.fizicka.adrese_list = this.$refs.adresaElement.$data;
    this.fizicka.izvor_osoba = this.$refs.imeIzvora.$data;
    this.fizicka.email_list = this.$refs.email.$data;
    this.fizicka.tel_br_list = this.$refs.telefon.$data;
    this.fizicka.web_list = this.$refs.stranica.$data;
    this.fizicka.custom_ime_izvora = this.$refs.customIzvor.$data;
    this.fizicka.radno_vrijeme = this.$refs.radnoVrijeme.$data;
    this.fizicka.opis = this.$refs.opis.$data;
    this.fizicka.rodjendan = this.$refs.datumRodjenja.value;
  },

  props: ["industrija", "tipovi_izvora", "fizicke", "clanovi", "pravne", "invalid_elements"],
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "adresa-element": adresaElement,
    "form-autocomplete-single": formAutocompleteSingle,
    "form-input-multiple": formInputMultiple,
  },
};
</script>
